import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IneDTO, IneDTOcall, ParticipantIneDTO } from '@app/requests/model/ine-model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class IneSignatureApi {
  constructor(private _http: HttpClient) {}

  sendSMS(smsParticipant: ParticipantIneDTO): Observable<any> {
    return this._http.post<IneDTO>(environment.URL_BASE_SIGNATURE + environment.subUrlSmsINE, smsParticipant);
  }

  getParticipantsPendingINE(ineDTO: IneDTOcall): Observable<IneDTO> {
    return this._http.post<IneDTO>(environment.URL_BASE_SIGNATURE + environment.subUrlINE, ineDTO);
  }
}
